import { Observable } from "rxjs";
import { ICustomerInvoiceParam } from "../components/yourBillingCycle/yourBillingCycle";
import { ApiEndpointResolver } from "./apiEndpointResolver";
import HttpClient from "./httpClient";

export const ArService = {
  getCustomerInvoiceParameters(): Observable<ICustomerInvoiceParam> {
    return HttpClient.get({
      baseUri: ApiEndpointResolver.getCustomerInvoiceParametersUrl(),
    });
  },
};
